<template>
  <div class="mobile-account-email-form dialog-content" :aria-busy="stepLoading">
    <div class="mobile-dialog-step" aria-live="polite">
      <p v-if="!currentEmail">{{ $t('views.account_center.no_email_tip') }}</p>
      <template v-else>
        <p>{{ $t('views.account_center.current_email_is') }}</p>
        <p class="mobile-dialog-identity">
          {{ currentEmail }}<span v-if="!oldEmailCodeSent">{{ $t('views.account_center.will_send_code') }}</span>
        </p>
        <p v-if="oldEmailVerified">{{ $t('views.account_center.verification_completed') }}</p>
      </template>
    </div>

    <div v-if="step >= 2 && !oldEmailVerified && currentEmail" class="mobile-dialog-field">
      <el-input
        data-account-field="old-code"
        :model-value="oldCode"
        :placeholder="$t('views.account_center.enter_verification_code')"
        :aria-label="$t('views.account_center.enter_verification_code')"
        @update:model-value="$emit('old-code-change', $event)"
      />
      <el-button
        data-account-action="resend-old"
        :disabled="oldEmailTimer > 0 || oldCodeSending || stepLoading"
        :loading="oldCodeSending"
        @click="$emit('send-old-code')"
      >
        {{ oldEmailTimer > 0 ? $t('views.account_center.retry_later', { newEmailTimer: oldEmailTimer }) : $t('views.account_center.resend') }}
      </el-button>
    </div>

    <div v-if="step >= 3" class="mobile-dialog-field">
      <p>{{ $t('views.account_center.enter_new_email') }}</p>
      <el-input
        data-account-field="new-email"
        :model-value="newEmail"
        :placeholder="$t('views.account_center.enter_new_email_placeholder')"
        :aria-label="$t('views.account_center.enter_new_email_placeholder')"
        inputmode="email"
        autocomplete="off"
        @update:model-value="$emit('new-email-change', $event)"
      />
    </div>

    <div v-if="step >= 4" class="mobile-dialog-field">
      <p class="mobile-dialog-identity">{{ $t('views.account_center.verification_tip', { email: newEmail }) }}</p>
      <el-input
        data-account-field="new-code"
        :model-value="newCode"
        :placeholder="$t('views.account_center.enter_new_email_code')"
        :aria-label="$t('views.account_center.enter_new_email_code')"
        @update:model-value="$emit('new-code-change', $event)"
      />
      <el-button
        data-account-action="resend-new"
        :disabled="newEmailTimer > 0 || newCodeSending || stepLoading"
        :loading="newCodeSending"
        @click="$emit('send-new-code')"
      >
        {{ newEmailTimer > 0 ? $t('views.account_center.retry_later', { newEmailTimer }) : $t('views.account_center.resend') }}
      </el-button>
    </div>

    <div class="mobile-dialog-actions">
      <el-button
        data-account-action="submit"
        type="primary"
        :loading="stepLoading"
        :disabled="stepLoading || oldCodeSending || newCodeSending"
        @click="$emit('submit')"
      >{{ actionText }}</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileAccountEmailForm',
  props: {
    currentEmail: { type: String, default: '' },
    step: { type: Number, required: true },
    oldCode: { type: String, default: '' },
    newEmail: { type: String, default: '' },
    newCode: { type: String, default: '' },
    oldEmailCodeSent: Boolean,
    oldEmailVerified: Boolean,
    oldEmailTimer: { type: Number, default: 0 },
    newEmailTimer: { type: Number, default: 0 },
    oldCodeSending: Boolean,
    newCodeSending: Boolean,
    stepLoading: Boolean,
    actionText: { type: String, default: '' }
  },
  emits: ['old-code-change', 'new-email-change', 'new-code-change', 'send-old-code', 'send-new-code', 'submit']
}
</script>
